











































































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import moment from "moment";
import DashboardDokterStore from "@/store/modules/DashboardDokterStore";
import TrenKunjunganLineChart from "@/components/dashboard/TrenKunjunganLineChart.vue";
import TrenKunjunganDoughnutChart from "@/components/dashboard/TrenKunjunganDoughnutChart.vue";
import {
  TREN_FORMAT,
  TREN_MAKS_HARI,
  cariPuncak,
  jumlahHari,
  labelPeriode,
  labelRentangSingkat,
  labelTanggalSumbu,
  periodeBulanan,
  periodeCustom,
  periodeHarian
} from "@/utils/trenKunjungan";
import {
  TrenKunjunganDokterData,
  TrenKunjunganKategori,
  TrenKunjunganParams,
  TrenKunjunganPeriode,
  TrenKunjunganPeriodeMode,
  TrenKunjunganPuncak
} from "@/types/daftarRegisterPasien";

const SERI: { key: TrenKunjunganKategori; label: string; warna: string }[] = [
  { key: "ralan", label: "Rawat Jalan (Poli)", warna: "#1E88E5" },
  { key: "ranap", label: "Rawat Inap (Ranap)", warna: "#43A047" },
  { key: "igd", label: "Gawat Darurat (IGD)", warna: "#E53935" }
];

@Component({
  components: {
    TrenKunjunganLineChart,
    TrenKunjunganDoughnutChart
  }
})
export default class TrenKunjunganDokter extends Vue {
  SERI = SERI;
  modePeriode: TrenKunjunganPeriodeMode = "harian";
  menuPeriode = false;
  hariIni = moment().format(TREN_FORMAT);
  periode: TrenKunjunganPeriode = periodeHarian(this.hariIni);
  bulan = this.hariIni.substr(0, 7);
  rentang: string[] = [];
  pesanRentang = "";

  get tren(): TrenKunjunganDokterData | null {
    return DashboardDokterStore.tren;
  }

  get trenLoading(): boolean {
    return DashboardDokterStore.trenLoading;
  }

  get bulanMaks(): string {
    return this.hariIni.substr(0, 7);
  }

  get labelPeriodeAktif(): string {
    return labelPeriode(this.tren ? this.tren.periode : this.periode);
  }

  get labelPemilih(): string {
    if (this.modePeriode === "bulanan") {
      return moment(this.bulan, "YYYY-MM").format("MMMM YYYY");
    }

    return labelRentangSingkat(this.periode);
  }

  get ringkasan() {
    const r = this.tren ? this.tren.ringkasan : null;

    return [
      {
        key: "ralan",
        judul: "Pasien Rawat Jalan",
        warna: "#1E88E5",
        total: r ? r.ralan.total : 0,
        rincian: [
          this.rincian("Pulang", r ? r.ralan.pulang : 0, "green--text"),
          this.rincian("Rujuk", r ? r.ralan.rujuk : 0, "blue--text"),
          this.rincian("Ranap", r ? r.ralan.ranap : 0, "orange--text")
        ]
      },
      {
        key: "igd",
        judul: "Pasien IGD",
        warna: "#E53935",
        total: r ? r.igd.total : 0,
        rincian: [
          this.rincian("Pulang", r ? r.igd.pulang : 0, "green--text"),
          this.rincian("Rujuk", r ? r.igd.rujuk : 0, "blue--text"),
          this.rincian("Ranap", r ? r.igd.ranap : 0, "orange--text"),
          this.rincian("Meninggal", r ? r.igd.meninggal : 0, "red--text")
        ]
      },
      {
        key: "ranap",
        judul: "Pasien Rawat Inap",
        warna: "#43A047",
        total: r ? r.ranap.total : 0,
        rincian: [
          this.rincian("Pulang", r ? r.ranap.pulang : 0, "green--text"),
          this.rincian("Rujuk", r ? r.ranap.rujuk : 0, "blue--text"),
          this.rincian("Meninggal", r ? r.ranap.meninggal : 0, "red--text")
        ]
      }
    ];
  }

  get dataGaris() {
    const harian = this.tren ? this.tren.harian : [];

    return {
      labels: harian.map(h => labelTanggalSumbu(h.tanggal, this.hariIni)),
      ralan: harian.map(h => h.ralan),
      igd: harian.map(h => h.igd),
      ranap: harian.map(h => h.ranap)
    };
  }

  get dataDonat(): Record<TrenKunjunganKategori, number> {
    const r = this.tren ? this.tren.ringkasan : null;

    return {
      ralan: r ? r.ralan.total : 0,
      igd: r ? r.igd.total : 0,
      ranap: r ? r.ranap.total : 0
    };
  }

  get totalPasien(): number {
    return this.dataDonat.ralan + this.dataDonat.igd + this.dataDonat.ranap;
  }

  get adaData(): boolean {
    return this.totalPasien > 0;
  }

  get puncak(): TrenKunjunganPuncak | null {
    return this.tren ? cariPuncak(this.tren.harian) : null;
  }

  get labelPuncak(): string {
    if (!this.puncak) {
      return "";
    }

    const hari = moment(this.puncak.tanggal, TREN_FORMAT).format("dddd, D MMM");
    const penanda = this.puncak.tanggal === this.hariIni ? " (Hari ini)" : "";

    return `${hari}${penanda} · ${this.puncak.total} Pasien`;
  }

  rincian(label: string, nilai: number, kelas: string) {
    return { label, nilai, kelas };
  }

  persen(nilai: number): string {
    if (!this.totalPasien) {
      return "0%";
    }

    return `${Math.round((nilai / this.totalPasien) * 100)}%`;
  }

  @Watch("modePeriode")
  onModePeriode(mode: TrenKunjunganPeriodeMode) {
    this.pesanRentang = "";

    if (mode === "harian") {
      this.menuPeriode = false;
      this.periode = periodeHarian(this.hariIni);
      this.muat();

      return;
    }

    if (mode === "bulanan") {
      this.bulan = this.hariIni.substr(0, 7);
      this.periode = periodeBulanan(this.bulan, this.hariIni);
      this.muat();

      return;
    }

    this.rentang = [this.periode.start, this.periode.end];
    this.menuPeriode = true;
  }

  terapkanBulan(bulan: string) {
    this.menuPeriode = false;
    this.periode = periodeBulanan(bulan, this.hariIni);
    this.muat();
  }

  terapkanCustom(tanggal: string[]) {
    const periode = periodeCustom(tanggal, this.hariIni);

    if (!periode) {
      return;
    }

    if (jumlahHari(periode) > TREN_MAKS_HARI) {
      this.pesanRentang = `Rentang periode maksimal ${TREN_MAKS_HARI} hari. Pilih ulang tanggal.`;

      return;
    }

    this.pesanRentang = "";
    this.menuPeriode = false;
    this.periode = periode;
    this.muat();
  }

  muat(fresh = false) {
    this.hariIni = moment().format(TREN_FORMAT);

    if (this.modePeriode === "harian") {
      this.periode = periodeHarian(this.hariIni);
    }

    const params: TrenKunjunganParams = {
      start: this.periode.start,
      end: this.periode.end
    };

    if (fresh) {
      params.fresh = 1;
    }

    DashboardDokterStore.fetchTren(params);
  }

  mounted() {
    this.muat();
  }
}
